export const frontmatter = {"title":"Pages"};
export const toc = [];